import {
  DEV_SERVER_URL,
  PROD_SERVER_URL,
  LOCAL_SERVER_URL,
} from '../../constants/utils.constants';

export function getSocketServerUrl(): string {
  const hostname = window.location.hostname;
  switch (hostname) {
    case 'localhost':
    case '127.0.0.1':
      return new URL(LOCAL_SERVER_URL).origin;
    case 'shanenli-web-app.fly.dev':
      return new URL(DEV_SERVER_URL).origin;
    case 'app.shanen.li':
      return new URL(PROD_SERVER_URL).origin;
    default:
      if (/^192\.168\.|^10\.|^172\.(1[6-9]|2\d|3[01])\./.test(hostname)) {
        return `http://${hostname}:3000`;
      }
      return new URL(DEV_SERVER_URL).origin;
  }
}

export interface TranscriptPayload {
  type: 'final' | 'partial';
  text: string;
  /** Segment start time (seconds, relative to audio) — speechmatics metadata. */
  start_time?: number;
  /** Segment end time (seconds, relative to audio) — speechmatics metadata. */
  end_time?: number;
  /** Per-word timings + speechmatics' own confidence (0.0–1.0) — speechmatics results. */
  times?: Array<{ start_time: number; end_time: number; confidence?: number }>;
}

export interface ServerToClientEvents {
  transcript: (payload: TranscriptPayload) => void;
  transcriptError: () => void;
  /** סשן התמלול בשרת פתוח - מכאן והלאה השמע באמת נקלט */
  streamReady: () => void;
}

export interface ClientToServerEvents {
  /** The token identifies the reader, so their log lines are filed under them. */
  startStream: (auth?: { token?: string }) => void;
  stopStream: (logsData: Array<any>) => void;
  audioData: (aData: ArrayBuffer) => void;
}